import React from 'react'
import { VictoryBar, VictoryLabel, VictoryStack } from 'victory'
import Rainbow from 'rainbowvis.js'
import { withErrorBoundary } from '../errors/ErrorBoundary'

const gradient = new Rainbow()
gradient.setSpectrum('green', 'yellow', 'red')

const renderStackedBars = ({ dataArray, height, dx }) => {
  const width = dx ? dx : 150 / dataArray.length
  const stackedBars = dataArray.map(data => {
    const { label, color, style={}, dx } = data

    return (
      <VictoryBar
        key={label}
        style={{ data: { fill: color } }}
        data={[{ label, x: label, y: width }]}
        labelComponent={
          <VictoryLabel
            dx={dx ? -dx : -width}
            style={{
              fontSize: height * 0.7,
              fill: 'black',
              stroke: 'white',
              strokeWidth: 0.1,
              strokeOpacity: 0.2,
              ...style
            }}
          />
        }
      />
    )
  })

  return stackedBars
}

const LegendCategorical = props => {
  const { layer, height, width, margin, padding, dx } = props
  const { legend } = layer

  return (
    <VictoryStack
      horizontal
      standalone={false}
      padding={padding}
      margin={margin}
      height={height}
      width={width}
    >
      {legend.type === 'categorical' &&
      renderStackedBars({ dataArray: legend.data, height, dx })}
    </VictoryStack>
  )
}

const Legend = props => {
  const {
    layer,
    width = 200,
    height = 10,
    padding = { top: 0, bottom: 0, left: 0, right: 0 },
    margin = { top: 0, bottom: 0, left: 0, right: 0 }
  } = props

  if (!layer || !layer.legend) {
    return <div />
  }

  const { legend } = layer
  const { dx } = legend

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      style={{ width: '100%', height: 'auto', paddingBottom: '20px' }}
    >
      {legend.type === 'categorical' &&
      LegendCategorical({ layer, height, width, padding, margin, dx })}
    </svg>
  )
}

export default withErrorBoundary(Legend)



// WEBPACK FOOTER //
// ./src/components/Legend.js